<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/order/list' }">
          <i class="el-icon-s-order"></i> 展会订单列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-plus"></i> {{ form.id ? '编辑订单' : '新建展会订单' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="never">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
        label-position="right"
        size="small"
      >
        <div class="form-block">
          <h3 class="block-title">基础订单信息</h3>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="订单编号" prop="order_no">
                <el-input v-model="form.order_no" placeholder="自动生成" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="选择展会" prop="expo_id">
                <el-select
                  v-model="form.expo_id"
                  placeholder="请选择展会"
                  clearable
                  style="width:100%"
                  @change="handleExpoChange"
                >
                  <el-option
                    v-for="item in expoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务员" prop="seller_id">
                <el-select
                  v-model="form.seller_id"
                  placeholder="选择业务员"
                  clearable
                  style="width:100%"
                >
                  <el-option
                    v-for="item in sellerList"
                    :key="item.id"
                    :label="item.name_cn"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="展商名称" prop="company_name">
                <el-input v-model="form.company_name" placeholder="输入企业/展商名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系手机号" prop="mobile">
                <el-input v-model="form.mobile" placeholder="11位手机号码" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付方式" prop="pay_type">
                <el-radio-group v-model="form.pay_type">
                  <el-radio :label="1">微信支付</el-radio>
                  <el-radio :label="2">线下转账</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-block">
          <h3 class="block-title">展位选择</h3>
          <div class="booth-select-bar">
            <el-button type="primary" icon="el-icon-search" @click="openBoothSelect">选择展位</el-button>
            <span v-if="selectedBoothList.length > 0" class="tip-text">已选 {{ selectedBoothList.length }} 个展位</span>
            <el-button type="text" @click="clearAllBooth" v-if="selectedBoothList.length>0">清空全部展位</el-button>
          </div>
          <el-table
            :data="selectedBoothList"
            border
            size="mini"
            style="margin-top:16px;"
            v-if="selectedBoothList.length>0"
          >
            <el-table-column label="展位编号" prop="sn" align="center"></el-table-column>
            <el-table-column label="面积(㎡)" prop="area" align="center"></el-table-column>
            <el-table-column label="单价(元)" prop="amount" align="center"></el-table-column>
            <el-table-column label="展位状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==1" type="warning" size="mini">已预订</el-tag>
                <el-tag v-else type="success" size="mini">可预订</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-delete" @click="removeBooth(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="booth-stat" style="margin-top:12px;">
            <el-tag type="primary" effect="plain">总展位面积：{{ totalArea }} ㎡</el-tag>
            <el-tag type="danger" effect="plain" style="margin-left:12px;">订单总金额：￥{{ totalAmount }}</el-tag>
          </div>
        </div>

        <div class="form-block">
          <h3 class="block-title">金额配置</h3>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="订单总金额" prop="total_amount">
                <el-input-number
                  v-model="form.total_amount"
                  :min="0"
                  step="0.01"
                  placeholder="自动计算"
                  disabled
                  style="width:100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预付金额" prop="prepay_amount">
                <el-input-number
                  v-model="form.prepay_amount"
                  :min="0"
                  :max="form.total_amount"
                  step="0.01"
                  placeholder="可修改预付金额"
                  style="width:100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付状态" prop="pay_status">
                <el-select v-model="form.pay_status" style="width:100%" :disabled="!!form.id">
                  <el-option label="待支付" :value="0"></el-option>
                  <el-option label="已支付" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="form-block">
          <h3 class="block-title">备注说明</h3>
          <el-form-item label="订单备注">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              placeholder="填写订单备注、特殊需求等"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>

      <div class="form-footer">
        <el-button size="medium" @click="backList">返回列表</el-button>
        <el-button size="medium" type="primary" @click="submitForm">保存订单</el-button>
      </div>
    </el-card>

    <!-- 展位选择弹窗 -->
    <el-dialog title="选择可用展位" :visible.sync="boothDialog" width="750px" class="alipay-dialog">
      <el-table
        :data="boothSelectList"
        border
        size="mini"
        v-loading="boothLoading"
        ref="boothTable"
        @selection-change="handleBoothSelection"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="展位编号" prop="sn" align="center"></el-table-column>
        <el-table-column label="面积" prop="area" align="center"></el-table-column>
        <el-table-column label="单价" prop="amount" align="center"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status===1" type="danger" size="mini">已售出</el-tag>
            <el-tag v-else-if="scope.row.status===2" type="warning" size="mini">已预订</el-tag>
            <el-tag v-else type="success" size="mini">可选择</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="boothDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmSelectBooth">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ExpoOrderForm",
  data() {
    return {
      // 表单
      form: {
        id: "",
        order_no: "",
        expo_id: "",
        seller_id: "",
        company_name: "",
        mobile: "",
        pay_type: 1,
        total_amount: 0,
        prepay_amount: 0,
        pay_status: 0,
        remark: ""
      },
      rules: {
        expo_id: [{ required: true, message: "请选择展会", trigger: "change" }],
        company_name: [{ required: true, message: "请输入展商名称", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" }
        ],
        total_amount: [{ required: true, message: "订单金额不能为空", trigger: "blur" }]
      },
      // 下拉数据源
      expoList: [],
      sellerList: [],
      // 选中展位
      selectedBoothList: [],
      // 展位弹窗
      boothDialog: false,
      boothLoading: false,
      boothSelectList: [],
      tempSelectBooth: []
    }
  },
  computed: {
    totalArea() {
      return this.selectedBoothList.reduce((sum, item) => sum + Number(item.area), 0)
    },
    totalAmount() {
      return this.selectedBoothList.reduce((sum, item) => sum + Number(item.amount), 0).toFixed(2)
    }
  },
  created() {
    this.getExpoSelect()
    this.getSellerList()
    this.initEditData()
  },
  methods: {
    // 编辑回填
    initEditData() {
      const id = this.$route.query.id
      if (!id) return
      this.form.id = id
      this.getOrderDetail(id)
    },
    // 获取展会下拉
    getExpoSelect() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token")
      }
      this.$axios.getExpoSelect(param).then(res => {
        if (res.code === 200) this.expoList = res.data
      })
    },
    // 获取业务员下拉
    getSellerList() {
      const param = {
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token")
      }
      this.$axios.getSellerList(param).then(res => {
        if (res.code === 200) this.sellerList = res.data
      })
    },
    // 切换展会 加载可选展位
    handleExpoChange() {
      this.selectedBoothList = []
      this.form.total_amount = 0
      if (!this.form.expo_id) return
      this.loadBoothByExpo()
    },
    loadBoothByExpo() {
      this.boothLoading = true
      const param = {
        expo_id: this.form.expo_id,
        company_id: sessionStorage.getItem("company_id"),
        access_token: sessionStorage.getItem("token")
      }
      this.$axios.getBoothByExpo(param).then(res => {
        this.boothLoading = false
        if (res.code === 200) {
          // 只返回可预订展位 status=0
          this.boothSelectList = res.data.filter(item => item.status === 0)
        }
      }).catch(() => {
        this.boothLoading = false
      })
    },
    // 打开展位弹窗
    openBoothSelect() {
      if (!this.form.expo_id) {
        return this.$message.warning("请先选择展会")
      }
      this.tempSelectBooth = []
      this.boothDialog = true
      this.$nextTick(() => {
        // 回填已选中
        const ids = this.selectedBoothList.map(i => i.id)
        this.$refs.boothTable.toggleAllSelection(false)
        this.boothSelectList.forEach(row => {
          if (ids.includes(row.id)) this.$refs.boothTable.toggleRowSelection(row, true)
        })
      })
    },
    // 多选展位回调
    handleBoothSelection(val) {
      this.tempSelectBooth = val
    },
    // 确认选择展位
    confirmSelectBooth() {
      this.selectedBoothList = JSON.parse(JSON.stringify(this.tempSelectBooth))
      this.form.total_amount = this.totalAmount
      this.boothDialog = false
    },
    // 移除单个展位
    removeBooth(index) {
      this.selectedBoothList.splice(index, 1)
      this.form.total_amount = this.totalAmount
    },
    // 清空所有展位
    clearAllBooth() {
      this.selectedBoothList = []
      this.form.total_amount = 0
    },
    // 获取订单详情（编辑）
    getOrderDetail(id) {
      const param = { id }
      this.$axios.getOrderDetail(param).then(res => {
        if (res.code !== 200) return
        const data = res.data
        this.form = {
          id: data.id,
          order_no: data.order_no,
          expo_id: data.expo_id,
          seller_id: data.seller_id,
          company_name: data.company_name,
          mobile: data.mobile,
          pay_type: data.pay_type,
          total_amount: data.total_amount,
          prepay_amount: data.prepay_amount,
          pay_status: data.pay_status,
          remark: data.remark
        }
        // 加载展位
        this.selectedBoothList = data.booth_list || []
        // 加载当前展会展位
        this.$nextTick(() => this.loadBoothByExpo())
      })
    },
    // 提交保存
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (this.selectedBoothList.length === 0) {
          return this.$message.warning("请至少选择一个展位")
        }
        const boothIds = this.selectedBoothList.map(item => item.id)
        const params = {
          ...this.form,
          company_id: sessionStorage.getItem("company_id"),
          proxy_id: sessionStorage.getItem("proxy_id") || 0,
          booth_ids: boothIds
        }
        let res
        if (this.form.id) {
          res = await this.$axios.editOrder(params)
        } else {
          res = await this.$axios.addOrder(params)
        }
        if (res.code === 200) {
          this.$message.success(this.form.id ? "修改成功" : "创建订单成功")
          this.backList()
        } else {
          this.$message.error(res.msg || "操作失败")
        }
      })
    },
    // 返回列表
    backList() {
      this.$router.replace("/order/list")
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}
.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb {
    font-size: 14px;
    i {
      margin-right: 4px;
    }
  }
}
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
  .el-card__body {
    padding: 20px 24px;
  }
}
.form-block {
  background: #f8f9fc;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  .block-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
    margin: 0 0 16px;
    padding-left: 8px;
    border-left: 4px solid #1677ff;
  }
}
.booth-select-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  .tip-text {
    color: #606266;
  }
}
.form-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px dashed #e4e7ed;
  .el-button {
    border-radius: 24px;
    padding: 9px 28px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
.alipay-dialog .el-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    padding: 20px 24px;
    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  .el-button {
    border-radius: 24px;
    padding: 9px 24px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
  }
}
::v-deep .el-form-item__label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}
::v-deep .el-input__inner,
::v-deep .el-select__inner,
::v-deep .el-textarea__inner {
  border-radius: 20px;
}
</style>